import LocalForage from 'localforage';

function error() {
  return {
    type: 'error',
    message: 'API__ERROR_LOCAL_FORAGE',
  };
}

export default class ApiStorage {
  static async get(store) {
    if (!store) {
      return Promise.resolve(null);
    }
    try {
      const dbData = await LocalForage.getItem(store.key);
      if (!dbData) {
        return Promise.resolve(null);
      }
      if (dbData.time < Date.now()) {
        return Promise.resolve(null);
      }
      return Promise.resolve(dbData.data);
    } catch (e) {
      return Promise.reject(error());
    }
  }

  static async set(store, data) {
    if (!store) {
      return Promise.resolve(data);
    }
    try {
      await LocalForage.setItem(store.key, {
        data,
        time: Date.now() + store.time,
      });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(error());
    }
  }

  static async remove(key) {
    try {
      if (!key) {
        await LocalForage.clear();
        return Promise.resolve();
      }
      await LocalForage.removeItem(key);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(error());
    }
  }

  static async removeGroup(name) {
    try {
      if (!name) {
        return Promise.resolve();
      }
      const keys = await LocalForage.keys();
      const all = [];
      keys.forEach((i) => {
        if (i.indexOf(name) === 0) {
          all.push(ApiStorage.remove(i));
        }
      });
      await Promise.all(all);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  static async keys() {
    try {
      const keys = await LocalForage.keys();
      return Promise.resolve(keys);
    } catch (e) {
      return Promise.reject(error());
    }
  }


  constructor(request) {
    this.store = request?.store;
  }

  get() {
    return ApiStorage.get(this.store);
  }

  set(data) {
    return ApiStorage.get(this.store, data);
  }

  remove() {
    if (!this.store?.key) {
      return Promise.resolve();
    }
    return ApiStorage.get(this.store.key);
  }

  removeGroup(name) {
    return ApiStorage.removeGroup(name);
  }
}
